import { render, staticRenderFns } from "./ingredientWizard.vue?vue&type=template&id=7a05ae18&scoped=true&"
import script from "./ingredientWizard.vue?vue&type=script&lang=js&"
export * from "./ingredientWizard.vue?vue&type=script&lang=js&"
import style0 from "./ingredientWizard.vue?vue&type=style&index=0&id=7a05ae18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a05ae18",
  null
  
)

export default component.exports